import React from "react";
import { APP_PREFIX_PATH } from "../AppConfig";

export const legalDocument = [
	{
		key: "legal-document-categories",
		path: `${APP_PREFIX_PATH}/legal-document-categories`,
		component: React.lazy(() => import("views/app-views/legal-document-categories")),
	},
	{
		key: "legal-documents",
		path: `${APP_PREFIX_PATH}/legal-document-categories/:categoryID`,
		component: React.lazy(() => import("views/app-views/legal-documents")),
	},
	{
		key: "legal-document",
		path: `${APP_PREFIX_PATH}/legal-documents/:documentID`,
		component: React.lazy(() => import("views/app-views/legal-documents/content-edit")),
	},
	{
		key: "business_sectors",
		path: `${APP_PREFIX_PATH}/sectors`,
		component: React.lazy(() => import("views/app-views/business_sectors")),
	},
];
